import React from "react";
import { Image, Stack, Text, useTheme } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import Frame from "../Frame";
import { BLACK_FRIDAY_BG_COLOR, BLACK_FRIDAY_IMAGE_URL_SMALL } from "../../../constants";
import styles from "./BlackFridayBanner.module.css";

const BlackFridayBanner = () => {
  const i18n = useI18n();
  const theme = useTheme();

  return (
    <Frame attributes={{ style: { width: "100%" } }} grow={1} p={4}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        attributes={{ style: { height: 300, backgroundColor: BLACK_FRIDAY_BG_COLOR, padding: theme.units.spacing_4x } }}
      >
        <Stack.Item grow>
          <Text color="white" variant="headline_3" attributes={{ style: { maxWidth: 160 } }}>
            {i18n.trans(t("flights_mdot_fly_anywhere_blackfriday_title"))}
          </Text>
        </Stack.Item>
        <Image
          src={BLACK_FRIDAY_IMAGE_URL_SMALL}
          className={styles.image}
          alt={i18n.trans(t("a11y_flights_blackfriday25_hero_image"))}
        ></Image>
      </Stack>
    </Frame>
  );
};

export default BlackFridayBanner;
